<template>
  <div>
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">
        Water Crossing Activities
      </h5>
    </b-form-row>
    <p v-if="waterCrossingExists">
      Water crossing(s) <strong>WILL</strong> be constructed as part of this Operation. Please
      review water crossing requirements in the Important Reminders section below.
    </p>
    <p v-else>
      No Water Crossing Activity is proposed.
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WaterCrossingDetails',
  computed: {
    ...mapGetters('Activity', ['waterCrossingExists']),
  },
};
</script>
